import { render, staticRenderFns } from "./MnemonicTableToDisplay.vue?vue&type=template&id=3b1bdd33&scoped=true&"
import script from "./MnemonicTableToDisplay.vue?vue&type=script&lang=js&"
export * from "./MnemonicTableToDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MnemonicTableToDisplay.vue?vue&type=style&index=0&id=3b1bdd33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1bdd33",
  null
  
)

export default component.exports